import React, { lazy } from "react";
import PrivateRoute from "../../components/PrivateRoute";
import { Routes } from "../../context/App";

const LandingPage = lazy(() => import("../../pages/LandingPage"));

interface HomePageProps {
  route: typeof Routes.LANDINGPAGE;
  path: string;
  exact: boolean;
}

const LandingPageRoute: React.FC<HomePageProps> = (props) => {
  const { route, path, exact } = props;
  return (
    <PrivateRoute
      path={path}
      route={route}
      exact={exact}
      Component={LandingPage}
    />
  );
};

export default LandingPageRoute;
